<div class="banner">
  <div class="banner-container">
    <div class="banner-container__content">
      <p class="banner-container__content--tag bannerText_color">{{bannerContent.tag}}</p>
      <h3 class="banner-container__content--title bannerText_color">{{bannerContent.title}}</h3>
      <p class="banner-container__content--subTitle bannerText_color">{{bannerContent.subTitle}}</p>
      <div class="banner-container__content--navigation">
        @for (btn of bannerContent.navigation; track btn) {
          <div>
            <button class="banner-container__content--navigation-btn-{{btn.id}} {{btn.id}}_color"
              (click)="navigateTo(btn)">
            {{btn.text}}</button>
          </div>
        }
      </div>
    </div>
    <div class="banner-container__image">
      <img [src]="blobURL + bannerContent.bannerImg"/>
    </div>
  </div>
</div>
